/* unplugin-vue-components disabled */import script from "./MemberLinkAction.vue?vue&type=script&lang=ts&setup=true"
export * from "./MemberLinkAction.vue?vue&type=script&lang=ts&setup=true"

import "./MemberLinkAction.vue?vue&type=style&index=0&id=cc47f63c&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc47f63c"]])

export default __exports__